import { render, staticRenderFns } from "./FrsOverview.vue?vue&type=template&id=00f4a7a4&scoped=true&lang=html&"
import script from "./FrsOverview.vue?vue&type=script&lang=js&"
export * from "./FrsOverview.vue?vue&type=script&lang=js&"
import style0 from "./FrsOverview.vue?vue&type=style&index=0&id=00f4a7a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f4a7a4",
  null
  
)

export default component.exports